import script from "./ProductCategoryDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCategoryDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCategoryDetail.vue?vue&type=style&index=0&id=b3ded06e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3ded06e"]])

export default __exports__